module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " till ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " har valts");
  },
  "finishRangeSelectionPrompt": "Klicka f\xF6r att avsluta val av datumintervall",
  "maximumDate": "Sista tillg\xE4ngliga datum",
  "minimumDate": "F\xF6rsta tillg\xE4ngliga datum",
  "next": "N\xE4sta",
  "previous": "F\xF6reg\xE5ende",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valt datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valt intervall: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Klicka f\xF6r att v\xE4lja datumintervall",
  "todayDate": function todayDate(args) {
    return "Idag, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Idag, ".concat(args.date, " har valts");
  }
};